import { useSyncExternalStore } from 'react';
import { getPlatformStatus, getServerPlatformStatus, subscribePlatformStatus, type PlatformStatus } from './platformStatus';

export const usePlatformStatus = (): PlatformStatus => useSyncExternalStore(subscribePlatformStatus, getPlatformStatus, getServerPlatformStatus);
